import type { WidgetType } from '@/lib/analytics/widget/widget.type';
import { SIZE_FULL } from '@/lib/gridElements/size';

import { MediasWidget } from '@/components/pages/analyze/widget/MediasWidget';

export const mostRecentVideosConfig: WidgetType<typeof MediasWidget> = {
    title: 'chart.youtube.widget_most_recent_videos',
    id: 'widget_most_recent_posts',
    noSortTypesSelect: true,
    size: SIZE_FULL,
    sortFields: ['created', 'engagement_rate', 'views', 'engagement_on_views'],
    type: 'widget',
    element: MediasWidget
};
